import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {
  RequestAddDto,
  RequestDeleteDto,
  RequestSaveDto,
  ResponseCompanySettingDto,
  ResponseEmployeeShiftDto,
  ResponseHistoryDto,
  ResponseReasonDto,
  ResponseSaveDto,
  ResponseTypeDto,
  ResponseAddDto,
  ResponseCancelAvailabilityDto,
  EmpDto,
  RequestUpdatePostDto,
} from "../dto/overtime.dto";
import {NestApiProvider} from "../../nest-api";

@Injectable()
export class OvertimeApi {

  private readonly service: string = '';
  private readonly model: string = 'sf6s/overtime';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public avatar(empId: string): Observable<any> {
    const method: string = 'GET';
    const func: string = 'avatar';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof empId !== 'undefined' && empId !== null) urlParams.empId = empId;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, func, params, body);
  }


  public history(empId: string, limit: string | number, skip: string | number): Observable<ResponseHistoryDto> {
    const method: string = 'GET';
    const func: string = 'history';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof empId !== 'undefined' && empId !== null) urlParams.empId = empId;
    if (typeof limit !== 'undefined' && limit !== null) urlParams.limit = limit;
    if (typeof skip !== 'undefined' && skip !== null) urlParams.skip = skip;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseHistoryDto>(method, url, func, params, body);
  }

  public cancelDetail(requestNo: string): Observable<any> {
    const method: string = 'GET';
    const func: string = 'ovtCancelDetail';
    const params: any = {};
    const urlParams: any = {requestNo: requestNo};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseHistoryDto>(method, url, func, params, body);
  }

  public historyDetail(requestNo: string): Observable<ResponseHistoryDto> {
    const method: string = 'GET';
    const func: string = 'history';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof requestNo !== 'undefined' && requestNo !== null) urlParams.requestNo = requestNo;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseHistoryDto>(method, url, func, params, body);
  }

  public todayShift(empId: string, date: Date): Observable<any> {
    const method: string = 'GET';
    const func: string = 'todayShift';
    const params: any = {};
    const urlParams: any = {empId: empId, date: date};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, func, params, body);
  }

  public cancelAvailability(requestNo: string): Observable<ResponseCancelAvailabilityDto> {
    const method: string = 'GET';
    const func: string = 'cancelAvailability';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof requestNo !== 'undefined' && requestNo !== null) urlParams.requestNo = requestNo;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseCancelAvailabilityDto>(method, url, func, params, body);
  }

  public companySetting(): Observable<ResponseCompanySettingDto> {
    const method: string = 'GET';
    const func: string = 'companySetting';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseCompanySettingDto>(method, url, func, params, body);
  }

  public reason(): Observable<ResponseReasonDto> {
    const method: string = 'GET';
    const func: string = 'reason';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseReasonDto>(method, url, func, params, body);
  }

  public emp(param: any): Observable<EmpDto> {
    const method: string = 'POST';
    const func: string = 'getEmp';
    const params: any = { };
    const urlParams: any = {};
    const body: any = {};
    const tempModel = 'sfcareer';

    if (typeof param.empId !== 'undefined' && param.empId !== null) params.empId = param.empId;
    if (typeof param.userId !== 'undefined' && param.userId !== null) params.userId = param.userId;
    if (typeof param.gender !== 'undefined' && param.gender !== null) params.gender = param.gender;
    if (typeof param.fullName !== 'undefined' && param.fullName !== null) params.fullName = param.fullName;

    const url = this.nestApiProvider.urlBuilder(method, tempModel, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseTypeDto>(method, url, params, urlParams, body);
  }

  public multiAttendData(param): Observable<any> {
    const method: string = 'GET';
    const func: string = 'multiAttendData';
    const params: any = {};
    const urlParams: any = { param };
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseTypeDto>(method, url, func, params, body);
  }

  public leavetype(empId: string): Observable<ResponseTypeDto> {
    const method: string = 'GET';
    const func: string = 'leavetype';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof empId !== 'undefined' && empId !== null) urlParams.empId = empId;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseTypeDto>(method, url, func, params, body);
  }

  public employeeShift(empId: any, companyId: any, startDate: any, endDate: any): Observable<ResponseEmployeeShiftDto> {
    const method: string = 'GET';
    const func: string = 'employeeShift';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof empId !== 'undefined' && empId !== null) urlParams.list_empid = empId;
    if (typeof companyId !== 'undefined' && companyId !== null) urlParams.company_id = companyId;
    if (typeof startDate !== 'undefined' && startDate !== null) urlParams.startdate = startDate;
    if (typeof endDate !== 'undefined' && endDate !== null) urlParams.enddate = endDate;
    
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseEmployeeShiftDto>(method, url, params, urlParams, body);
  }

  public employeeShiftOvt(payload: any): Observable<any> {
    const method: string = 'POST';
    const func: string = 'employeeShiftOvt';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof payload.list_empid !== 'undefined' && payload.list_empid !== null) params.list_empid = payload.list_empid;
    if (typeof payload.company_id !== 'undefined' && payload.company_id !== null) params.company_id = payload.company_id;
    if (typeof payload.startdate !== 'undefined' && payload.startdate !== null) params.startdate = payload.startdate;
    if (typeof payload.enddate !== 'undefined' && payload.enddate !== null) params.enddate = payload.enddate;
    if (typeof payload.diffdate !== 'undefined' && payload.diffdate !== null) params.diffdate = payload.diffdate;
    if (typeof payload.arrShiftDailies !== 'undefined' && payload.arrShiftDailies !== null) params.arrShiftDailies = payload.arrShiftDailies;
    if (typeof payload.objDetail !== 'undefined' && payload.objDetail !== null) params.objDetail = payload.objDetail;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, params, urlParams, body);
  }

  public validateCurrRequest(param): Observable<any> {
    const method: string = 'POST';
    const func: string = 'validateCurrRequest';
    const params: any = param || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseEmployeeShiftDto>(method, url, params, urlParams, body);
  }

  public add(payload: RequestAddDto): Observable<ResponseAddDto> {
    const method: string = 'POST';
    const func: string = 'add';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseAddDto>(method, url, params, urlParams, body);
  }

  public save(payload: RequestSaveDto): Observable<ResponseSaveDto> {
    const method: string = 'POST';
    const func: string = 'save';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseSaveDto>(method, url, params, urlParams, body);
  }

  public delete(payload: RequestDeleteDto): Observable<any> {
    const method: string = 'POST';
    const func: string = 'delete';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, params, urlParams, body);
  }

  public updatePost(payload: RequestUpdatePostDto): Observable<ResponseSaveDto> {
    const method: string = 'POST';
    const func: string = 'updatePost';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseSaveDto>(method, url, params, urlParams, body);
  }

  public feedOvt(requestNo: string): Observable<any> {
    const method: string = 'GET';
    const func: string = 'feedOvt';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof requestNo !== 'undefined' && requestNo !== null) urlParams.requestNo = requestNo;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-integrated/services/overtime.api.ts